import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Card from './components/Card';
import TabPane from './components/TabPane';
import Divider from './components/Divider';

var Group = function Group(props) {
  return /*#__PURE__*/React.createElement(Card, _extends({
    bodyStyle: {
      padding: 0
    }
  }, props));
}; // 当前不对底层 Card 做封装，仅挂载子组件，直接导出
// @ts-ignore


var ProCard = Card;
ProCard.isProCard = true;
ProCard.Divider = Divider;
ProCard.TabPane = TabPane;
ProCard.Group = Group;
export default ProCard;